/**
 * Add the base column when the customer has the enable_bases attribute active
 *
 * @param {Array} params.columns Columns of the current table
 * @param {Boolean} params.enableBases If bases are enabled in this customer
 * @param {String} params.prevColumnTitle Title of the previous title where the base column will be inserted
 *
 * @returns {Array} Columns with or without bases
 */

export function formatColumnsWithBases({
  columns = [],
  enableBases = false,
  prevColumnTitle = null,
} = {}) {
  /**
   * As the splice function mutates the array, its necessary to create a temporal copy of the
   * columns array in order to mutate it and not change the original columns
   */
  const tableColumns = [...columns];

  const prevColumnIdx = tableColumns.findIndex((column) => column.title === prevColumnTitle);
  const baseColumn = { title: "Base", dataIndex: "base", key: "base", width: 240, ellipsis: true };

  if (enableBases) tableColumns.splice(prevColumnIdx + 1, 0, baseColumn);

  return tableColumns;
}
